import React, { ReactNode } from 'react';
import PriceLabel from '@prisjakt/ui-price-label';
import StockStatus, { StockStatusType } from '@prisjakt/ui-stock-status';
import StoreLogo from '@prisjakt/ui-store-logo';
import Clickable from '@prisjakt/ui-clickable';
import Button from '@prisjakt/ui-button';
import { useCategoriesLargerImagesForMobile } from '../../../../../hooks/experiments';
import * as S from './styles';

type Props = {
  name: string;
  highlightedName?: ReactNode;
  image: ReactNode;
  price: number;
  storeId: number;
  featured: boolean;
  storeName: string;
  storePageLink: string;
  externalUri: string | null;
  stockStatus: StockStatusType;
  goToStoreText: string;
  hasStoreLogoImage: boolean;
  onClickGoToStore: () => void;
};

const OfferCard = ({
  name,
  highlightedName,
  image,
  price,
  storeId,
  featured,
  storeName,
  storePageLink,
  externalUri,
  stockStatus,
  goToStoreText,
  hasStoreLogoImage,
  onClickGoToStore,
}: Props) => {
  const showLargerImage = useCategoriesLargerImagesForMobile();
  const buttonIsDisabled = !externalUri;
  return (
    <S.Card showLargerImage={showLargerImage}>
      <S.CardZone>
        <S.ProductImage showLargerImage={showLargerImage}>
          {image}
        </S.ProductImage>
        <S.ProductDetails showLargerImage={showLargerImage}>
          <S.ProductName>{highlightedName || name}</S.ProductName>
        </S.ProductDetails>
      </S.CardZone>
      <S.CardZone>
        <S.ProductDetails showLargerImage={showLargerImage}>
          <Clickable to={storePageLink}>
            <StoreLogo
              name={storeName}
              storeId={storeId}
              featured={featured}
              hasImage={hasStoreLogoImage}
            />
          </Clickable>
        </S.ProductDetails>
        <S.PriceInfo showLargerImage={showLargerImage}>
          <PriceLabel value={price} />
          <StockStatus status={stockStatus} tooltip tooltipPlacement="top" />
        </S.PriceInfo>
        <Button
          color="positive"
          href={externalUri || ''}
          disabled={buttonIsDisabled}
          onClick={onClickGoToStore}
          rel="nofollow noopener"
          target="_blank"
          data-test="GoToStoreLink"
        >
          {goToStoreText}
        </Button>
      </S.CardZone>
    </S.Card>
  );
};

export default OfferCard;
